<div class="dropdowns">
    <ul>
        <li *ngIf="values.zoom">
		    <core-helpers-forms-input-number
            [disabled]="disabled"
            [label]="'Zoom'"
            (select)="toolSelect('zoom', $event)"
            [min]="30"
            [max]="100"
            [value]="values.zoom"
            ></core-helpers-forms-input-number>
        </li>
        <li *ngIf="values.register">
		    <core-helpers-forms-select
            [disabled]="disabled"
            [label]="'Align'"
            [options]="options.register"
            (select)="toolSelect('register', $event)"
            ></core-helpers-forms-select>
        </li>
        <!-- <li><core-helpers-forms-select
            [label]="'Keyline'"
            [options]="options.keyline"
            (selected)="toolSelect('keyline', $event)"
        ></core-helpers-forms-select></li>-->
        <li *ngIf="values.resolution">
		    <core-helpers-forms-select
            [disabled]="disabled"
            [label]="'Resolution'"
            [options]="options.resolution"
            (select)="toolSelect('resolution', $event)"
            ></core-helpers-forms-select>
		</li>
		<li *ngIf="values.method">
            <core-helpers-forms-select
                [optionSelected]="optionSelected"
                [disabled]="disabled"
                [label]="'Method'"
                [options]="options.method"
                (select)="toolSelect('method', $event)"
            ></core-helpers-forms-select>
		</li>
    </ul>
</div>
